import * as Yup from "yup";

export interface TicketFormValues {
	issueCategory: string;
	issueDescription: string;
}

export const ticketValidationSchema = Yup.object({
	issueCategory: Yup.string().required("Please select an issue type."),
	issueDescription: Yup.string()
		.trim()
		.required("Please describe the issue before submitting."),
});
